/* eslint-disable no-shadow */

import { client, collections } from '@/services/typesense.service';
import {
    developerRoleId, translatorRoleId, imageEditorRoleId,
} from '@/shared';

const state = {
    typesenseSearchResults: null,
    pending: false,
    error: null,
};

const getters = {
    loaded: (state) => !state.pending && state.typesenseSearchResults != null,
    typesenseSearchResults: (state, getters) => (getters.loaded ? state.typesenseSearchResults : []),
};

const mutations = {
    clearErrors(state) {
        state.error = null;
        state.updateError = null;
    },
    beforeLoading(state, initial = false) {
        if (initial) {
            state.typesenseSearchResults = null;
        }
        state.error = null;
        state.pending = true;
    },
    error(state, error) {
        state.pending = false;
        state.error = error;
    },
    data(state, { typesenseSearchResults }) {
        state.pending = false;
        state.typesenseSearchResults = typesenseSearchResults;
    },
};

const actions = {

    /**
     * Search Data in Typesense
     *
     * @param {object} commit
     * @param {object} payload
     */
    async searchRecords({ commit }, payload) {
        commit('beforeLoading');
        try {
            let filters = [];

            // Works on Intialial page start
            if (
                (payload.userRole === translatorRoleId
                || payload.userRole === developerRoleId
                || payload.userRole === imageEditorRoleId)
                && payload.userLanguage !== null
            ) {
                const projectIds = payload.userProjects.join(', ');
                filters = [
                    `project_id:=[${projectIds}]`,
                    `language_iso:=${payload.userLanguage.iso}`,
                ];
            }

            if (payload.userRole === developerRoleId && payload.userLanguage === null) {
                commit('data', { typesenseSearchResults: [] });
                return;
            }
            // Works on Intialial page end

            // Works on internal page start
            if (payload.activeProject && payload.activeLanguage) {
                filters = [
                    `project_id:=${payload.activeProject}`,
                    `language_iso:=${payload.activeLanguage}`,
                ];
            }
            // Works on internal page end

            const searchParameters = {
                q: payload.q,
                query_by: 'keyword_id,keyword_translated',
                per_page: 20,
                filter_by: filters.join('&&'),
            };

            const res = await client
                .collections(collections.keywords)
                .documents()
                .search(searchParameters);

            const typesenseSearchResults = res.hits.map((hits) => ({
                    id: hits.document.id,
                    keywordId: hits.document.keyword_id,
                    keywordKey: hits.document.keyword_key,
                    languageIso: hits.document.language_iso,
                    translation: hits.document.keyword_translated,
                    projectId: hits.document.project_id,
                    pageName: hits.document.page_name,
                }));
            commit('data', { typesenseSearchResults });
        } catch (error) {
            commit('error', error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
